(() => {
  const root = document.getElementById('StanCollectionsDirectory');
  if (!root) return;
  const input = root.querySelector('#StanCollectionsSearch');
  const items = [...root.querySelectorAll('[data-stan-collection]')];
  const groups = [...root.querySelectorAll('.stan-directory__group')];
  const none = root.querySelector('.stan-directory__none');
  const normalize = (value) => (value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  input.addEventListener('input', () => {
    const query = normalize(input.value.trim());
    let totalVisible = 0;
    items.forEach((item) => {
      const match = !query || normalize(item.dataset.stanTitle).includes(query);
      item.hidden = !match;
      if (match) totalVisible += 1;
    });
    groups.forEach((group) => {
      const visible = [...group.querySelectorAll('[data-stan-collection]')].some((item) => !item.hidden);
      group.hidden = !visible;
      if (query && visible) group.open = true;
    });
    none.hidden = totalVisible !== 0;
  });
})();